import React, { Component } from "react";
import PdfDownloader from "../PdfDownloader/PdfDownloader";
import { Waypoint } from "react-waypoint";

import Player from "../Player/Player";

import "./styles.scss";

class Outro extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }
  render() {
    return (
      <>
        <Waypoint
          horizontal
          onEnter={() => {
            this.props.chapterTransition("outro");
          }}
        >
          <div
            className="chapter chapter-outro outro"
            style={{ height: this.state.height + "px" }}
          >
            <div className="scroll-container bg">
              <div className="scroll"></div>
            </div>
            <div className="scroll-container one">
              <div className="scroll">
                <div className="icon"></div>
                <h2>
                  Tusen takk
                  <br />
                  for turen!
                </h2>
                <PdfDownloader
                  pdf="Hele"
                  text="Last ned hele fortellingen"
                ></PdfDownloader>
              </div>
            </div>
            <div className="scroll-container two">
              <div className="white-content scroll">
                <p>
                  Den siste tiden har dere, og mange andre skoleklasser over
                  hele landet, kildesortert skolemelkkartongene deres. Innsatsen
                  deres har hatt noe å si, uansett om dere har vært flittige som
                  maur eller midt på treet.
                </p>
                <h2>
                  Kildesorterer dere melkekartonger, bevarer dere skog, og alle
                  de små og store vesenene som bor i den!
                </h2>
                <Player file="outro_1" />
              </div>
            </div>
            <div className="scroll-container three">
              <div className="white-content scroll">
                <p>
                  Dere har også lært at neste gang dere går på stien og søker
                  skogens ro, er det egentlig ikke så stille der.
                </p>
                <h2>
                  Selv om skogen kan se rotete og skeiv ut ved første øyekast,
                  er det koko mye som skjer bak barken og under bakken.{" "}
                </h2>
                <p>
                  Ser dere godt nok etter, ser dere at eiketreet egentlig er som
                  en boligblokk med tusenvis av beboere, og at soppen har et
                  nettverk av tråder under bakken.
                </p>
              </div>
              <Player file="outro_2" />
            </div>
            <div className="scroll-container four">
              <div className="green-content scroll">
                <h2>
                  Takk for at dere har skylt, brettet og stappet for roteskogen.
                  Og for hakkespetten, trærne, mauren, blåveisen, skolopendere,
                  skrukketroll og sjokoladekjuker.
                </h2>
                <p>&nbsp;</p>
                <h2>
                  Nå kan dere lukke øynene, lene dere tilbake, og ta imot en
                  takk fra roteskogen selv.
                </h2>
              </div>
              <Player file="outro_3" />
            </div>
            <div className="scroll-container milk">
              <div className="scroll"></div>
            </div>
            <div className="scroll-container bear">
              <div className="scroll">
                <div className="bear"></div>
                <div className="bear-outline"></div>
              </div>
            </div>
          </div>
        </Waypoint>
      </>
    );
  }
}
export default Outro;
